import Controller from '@ember/controller';
import { service } from '@ember/service';
import JournalInfo from 'donor-elf-web/lib/models/journal-info';

export default class JournalsIndexController extends Controller {
  @service declare currentUser: any;

  get sortedJournalInfos(): JournalInfo[] {
    let journalInfos = (this.model.journalInfos as JournalInfo[]).sort(
      (a, b) => {
        return a.journal.startDate < b.journal.startDate ? 1 : -1;
      },
    );

    return [
      ...journalInfos.filter((x) => x.journal.active),
      ...journalInfos.filter((x) => !x.journal.active),
    ];
  }

  get hasJournals() {
    return this.model.journalInfos.length > 0;
  }
}
